import React from 'react'
import {Icon} from '@chakra-ui/react'

const EditIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" id="edit" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.70717 20.7071C8.56757 20.8467 8.38977 20.9419 8.19618 20.9806L3.19618 21.9806C2.49646 22.1205 1.87954 21.5036 2.01949 20.8039L3.01949 15.8039C3.05821 15.6103 3.15336 15.4325 3.29296 15.2929L15.293 3.29289C16.7881 1.7978 19.2121 1.7978 20.7072 3.29289C22.2023 4.78798 22.2023 7.21201 20.7072 8.7071L8.70717 20.7071ZM17.5859 9L7.50706 19.0788L4.27482 19.7252L4.92127 16.493L15.0001 6.41421L17.5859 9ZM19.0001 7.58578L19.293 7.29289C20.007 6.57885 20.007 5.42115 19.293 4.7071C18.5789 3.99306 17.4212 3.99306 16.7072 4.7071L16.4143 5L19.0001 7.58578Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EditIcon
